import {
  Component,
  HostListener,
  OnInit,
  QueryList,
  ViewChildren,
  ViewContainerRef
} from '@angular/core';

import { CalendarInnerComponent } from './calendar-inner.component';
import * as moment_ from '../utilities/lib-moment/moment-with-locales.custom.min';
import { getBrowserLocale } from './calendar-utility';
const moment = moment_;
// write an interface for template options
const TEMPLATE_OPTIONS: any = {
  bs3: {
    ARROW_LEFT: '<span class="material-icons">keyboard_arrow_left</span>',
    ARROW_RIGHT: '<span class="material-icons">keyboard_arrow_right</span>'
  }
};

@Component({
  selector: 'axis-calendar-daypicker',
  host: { class: 'axis-daypicker' },
  template: `
<div *ngIf="calendar.datepickerMode==='day'">
<div>
<table  role="grid">
  <thead>
    <tr>
      <th>
        <button type="button"
                axis-button
                data-kind="icon"
                (click)="calendar.move(-1)"
                tabindex="-1"
                [innerHTML]="CURRENT_THEME_TEMPLATE.ARROW_LEFT">
        </button>
      </th>
      <th [attr.colspan]="5">
            <button [id]="calendar.uniqueId + '-title'" axis-button
                type="button" class="datepicker-btn"
                (click)="calendar.toggleMode()"
                tabindex="-1">
                {{title}}
        </button>
      </th>
      <th>
        <button type="button"
                axis-button data-kind="icon"
                (click)="calendar.move(1)"
                tabindex="-1"
                [innerHTML]="CURRENT_THEME_TEMPLATE.ARROW_RIGHT">
        </button>
      </th>
    </tr>
    <tr>
      <th *ngFor="let labelz of labels">
        <span aria-label="labelz.full">{{labelz.abbr}}</span>
      </th>
    </tr>
  </thead>
  <tbody>
    <ng-template ngFor [ngForOf]="rows" let-rowz="$implicit" let-index="index">
      <tr *ngIf="!(calendar.onlyCurrentMonth && rowz[0].secondary && rowz[6].secondary)">
        <td *ngFor="let calendarInnerRef of rowz" role="gridcell" [id]="calendarInnerRef.uid" [ngClass]="(calendarInnerRef.secondary)?'is-other-month':''">
          <axis-calendar-daybtn [calendarInnerRef]="calendarInnerRef" #dayTempRefs></axis-calendar-daybtn>
        </td>
      </tr>
    </ng-template>
  </tbody>
</table>
</div>
</div>
  `
})
export class DayPickerCalendarComponent implements OnInit {
  public labels: any[] = [];
  public title: string;
  public rows: any[] = [];
  public weekNumbers: number[] = [];
  public calendar: CalendarInnerComponent;
  public CURRENT_THEME_TEMPLATE: any;
  private localeLanguage: string;
  public isTodayPresent = false;
  public tempDate: any;
  public validKeyPressed = false;
  @ViewChildren('dayTempRefs') dayTempRefs: QueryList<ViewContainerRef>;
  public constructor(
    calendar: CalendarInnerComponent,
  ) {
    this.CURRENT_THEME_TEMPLATE = TEMPLATE_OPTIONS.bs3;
    this.calendar = calendar;
  }

  public ngOnInit(): void {
    this.calendar.daySelected = true;
    let self: any = '';
    self = this;
    this.calendar.stepDay = { months: 1 };
    this.calendar.setRefreshViewHandler(function (): void {
      if (self.calendar.browserLocale) {
        self.localeLanguage = getBrowserLocale();
        moment.locale(self.localeLanguage);
      } else {
        self.localeLanguage = 'en-US';
        moment.locale(self.localeLanguage);
      }
      const year = this.activeDate.getFullYear();
      const month = this.activeDate.getMonth();
      const firstDayOfMonth = new Date(year, month, 1);
      const difference = this.startingDay - firstDayOfMonth.getDay();
      const numOfDaysInMonth = new Date(year, month + 1, 0).getDate();
      const numDisplayedFromPreviousMonth =
        difference > 0 ? 7 - difference : -difference;
      const firstDate = new Date(firstDayOfMonth.getTime());

      if (numDisplayedFromPreviousMonth > 0) {
        firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
      }

      // 42 is the number of days on a six-week calendar
      const totalDays = numOfDaysInMonth + numDisplayedFromPreviousMonth;
      const _days: Date[] = self.getDates(firstDate, totalDays);
      const days: any[] = [];
      for (let i = 0; i < totalDays; i++) {
        const _dateObject = this.createDateObject(_days[i], this.formatDay);
        _dateObject.secondary = _days[i].getMonth() !== month;
        _dateObject.uid = this.uniqueId + '-' + i;
        days[i] = _dateObject;

      }

      self.labels = [];
      for (let j = 0; j < 7; j++) {
        self.labels[j] = {};
        self.labels[j].abbr = this.dateFilter(
          days[j].date,
          this.formatDayHeader
        );
        self.labels[j].full = this.dateFilter(days[j].date, 'EEEE');
      }

      self.title = this.dateFilter(this.activeDate, this.formatDayTitle);
      self.rows = this.split(days, 7);
      self.rows.forEach(
        (element, index: number) => {
          element.forEach(item => {
            if (item.secondary === true) {
              item.label = '';
              item.date = '';
            }
          });
        });
      if (this.showWeeks) {
        self.weekNumbers = [];
        const thursdayIndex = (4 + 7 - this.startingDay) % 7;
        const numWeeks = self.rows.length;
        for (let curWeek = 0; curWeek < numWeeks; curWeek++) {
          self.weekNumbers.push(
            self.getISO8601WeekNumber(self.rows[curWeek][thursdayIndex].date)
          );
        }
      }
    }, 'day');

    this.calendar.setCompareHandler(function (
      date1: Date,
      date2: Date
    ): number {
      const d1 = date1
        ? new Date(date1.getFullYear(), date1.getMonth(), date1.getDate())
        : new Date();
      const d2 = new Date(
        date2.getFullYear(),
        date2.getMonth(),
        date2.getDate()
      );
      return d1.getTime() - d2.getTime();
    }, 'day');
    this.calendar.refreshView();
  }

  protected getDates(startDate: Date, n: number): Date[] {
    const dates: Date[] = new Array(n);
    let current = new Date(startDate.getTime());
    let i = 0;
    let date: Date;
    while (i < n) {
      date = new Date(current.getTime());
      date = this.calendar.fixTimeZone(date);
      dates[i] = date;
      i++;
      current = new Date(
        current.getFullYear(),
        current.getMonth(),
        current.getDate() + 1
      );
    }
    return dates;
  }

  protected getISO8601WeekNumber(date: Date): number {
    const checkDate = new Date(date.getTime());
    checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7));
    const time = checkDate.getTime();
    checkDate.setMonth(0);
    checkDate.setDate(1);
    return (
      Math.floor(Math.round((time - checkDate.getTime()) / 86400000) / 7) + 1
    );
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent) {
    if (this.calendar.dateRange) {
      if ((e.code !== 'Tab' || e.keyCode !== 9) && this.calendar.datepickerMode === 'day') {
        e.preventDefault();
        this.rangeKeyDownEvent(e);
      }
    } else {
      this.validKeyPressed = true;
      if ((e.code !== 'Tab' || e.keyCode !== 9) && this.calendar.datepickerMode === 'day') {
        this.calendar.calendarInnerRef.nativeElement.childNodes[0].click();
        this.dateUpdateOnKeyPress(this.dayTempRefs, e);
      }
    }
  }


  /**
     * Key events for the calendar.
     * TAB: moves focus to calendar.
     * LEFT_ARROW: Go to previous day.
     * RIGHT_ARROW: Go to next day.
     * UP_ARROW: Go to same day in the previous week.
     * DOWN_ARROW: Go to same day in the next week.
     * HOME: Go to the first day in the current range.
     * END: Go to the last day in the current range.
     * PAGE_UP: Go to the same day in the previous month
     * PAGE_DOWN:Go to the same day in the next month
     * ALT + PAGE_UP:Go to the same day in the previous year
     * ALT + PAGE_DOWN:Go to the same day in the next year
     * ENTER:Select current day
 
     * @param event as KeyboardEvent
     */

  rangeKeyDownEvent(e) {
    this.isTodayPresent = false;
    this.dayTempRefs.forEach(element => {
      const tempElement = element['btn'].nativeElement;
      this.tempDate = new Date(element['calendarInnerRef'].date);
      if (tempElement.children[0].classList.contains('date-today') && this.tempDate.getDate()) {
        this.isTodayPresent = true;
      }
    });
    if (e.code === 'ArrowDown' || e.keyCode === 40) {
      this.rangeArrowDown();
    } else if (e.code === 'ArrowUp' || e.keyCode === 38) {
      this.rangeArrowUp();
    }
    else if (e.code === 'ArrowLeft' || e.keyCode === 37) {
      this.rangeArrowLeft();
    } else if (e.code === 'ArrowRight' || e.keyCode === 39) {
      this.rangeArrowRight();
    }
    else if (e.code === 'Home' || e.keyCode === 36) {
      this.calendar.focusedDate = new Date(this.calendar.activeDate.getFullYear(), this.calendar.activeDate.getMonth(), 1);
    } else if (e.code === 'End' || e.keyCode === 35) {
      this.calendar.focusedDate = new Date(this.calendar.activeDate.getFullYear(), this.calendar.activeDate.getMonth() + 1, 0);
    } else if ((e.code === 'PageUp' || e.keyCode === 33) && e.altKey === false) {
      this.rangeArrowPageUp();
    } else if ((e.code === 'PageDown' || e.keyCode === 34) && e.altKey === false) {
      this.rangeArrowPageDown();
    }
    if (e.code === 'Enter' || e.keyCode === 13) {
      this.calendar.select(this.calendar.focusedDate, true);
    }

    if (e.altKey === true && (e.code === 'AltRight')) {
      // leap year
      if (this.calendar.focusedDate.getMonth() === 1 && (this.calendar.focusedDate.getDate() === 29)) {
        this.calendar.focusedDate = new Date(this.calendar.focusedDate.getFullYear() + 1, this.calendar.focusedDate.getMonth() + 1, 0);
      } else {
        this.calendar.focusedDate = new Date(this.calendar.focusedDate.getFullYear() + 1, this.calendar.focusedDate.getMonth(), this.calendar.focusedDate.getDate());
      }
      this.calendar.activeDate = this.calendar.focusedDate;
    } else if (e.altKey === true && (e.code === 'AltLeft')) {
      // leap year
      if (this.calendar.focusedDate.getMonth() === 1 && (this.calendar.focusedDate.getDate() === 29)) {
        this.calendar.focusedDate = new Date(this.calendar.focusedDate.getFullYear() - 1, this.calendar.focusedDate.getMonth() + 1, 0);
      } else {
        this.calendar.focusedDate = new Date(this.calendar.focusedDate.getFullYear() - 1, this.calendar.focusedDate.getMonth(), this.calendar.focusedDate.getDate());
      }
      this.calendar.activeDate = this.calendar.focusedDate;
    }
    this.calendar.activeDate = this.calendar.focusedDate;
    this.calendar.refreshView();
  }

  // This event is used for UP_ARROW: Go to same day in the previous week.
  rangeArrowUp() {
    if (this.calendar.focusedDate) {
      this.calendar.focusedDate = new Date(this.calendar.focusedDate.setDate(this.calendar.focusedDate.getDate() - 7));
    } else if(this.isTodayPresent) {
      this.calendar.focusedDate = new Date();
      this.calendar.focusedDate = new Date(this.calendar.focusedDate.setDate(this.calendar.focusedDate.getDate() - 7));
    } else  {
      this.calendar.focusedDate = new Date(this.calendar.activeDate.getFullYear(), this.calendar.activeDate.getMonth(), 1);
    }
  }
  // This event is used for DOWN_ARROW: Go to same day in the next week.
  rangeArrowDown() {
    if (this.calendar.focusedDate) {
      this.calendar.focusedDate = new Date(this.calendar.focusedDate.setDate(this.calendar.focusedDate.getDate() + 7));
    } else if(this.isTodayPresent) {
      this.calendar.focusedDate = new Date();
      this.calendar.focusedDate = new Date(this.calendar.focusedDate.setDate(this.calendar.focusedDate.getDate() + 7));
    } else  {
      this.calendar.focusedDate = new Date(this.calendar.activeDate.getFullYear(), this.calendar.activeDate.getMonth(), 1);
    }
  }

  // This event is used for LEFT_ARROW: Go to previous day.
  rangeArrowLeft() {
    if (this.calendar.focusedDate) {
      this.calendar.focusedDate = new Date(this.calendar.focusedDate.setDate(this.calendar.focusedDate.getDate() - 1));
    } else if(this.isTodayPresent) {
      this.calendar.focusedDate = new Date();
      this.calendar.focusedDate = new Date(this.calendar.focusedDate.setDate(this.calendar.focusedDate.getDate() - 1));
    } else  {
      this.calendar.focusedDate = new Date(this.calendar.activeDate.getFullYear(), this.calendar.activeDate.getMonth(), 1);
    }
  }

  // This event is used for RIGHT_ARROW: Go to next day.
  rangeArrowRight() {
    if (this.calendar.focusedDate) {
      this.calendar.focusedDate = new Date(this.calendar.focusedDate.setDate(this.calendar.focusedDate.getDate() + 1));
    } else if(this.isTodayPresent) {
      this.calendar.focusedDate = new Date();
      this.calendar.focusedDate = new Date(this.calendar.focusedDate.setDate(this.calendar.focusedDate.getDate() + 1));
    } else  {
      this.calendar.focusedDate = new Date(this.calendar.activeDate.getFullYear(), this.calendar.activeDate.getMonth(), 1);
    }
  }
  // This event is used for PAGE_UP: Go to the same day in the previous month
  rangeArrowPageUp() {
    if (this.calendar.focusedDate) {
      if (this.calendar.focusedDate.getDate() === 31) {
        this.calendar.focusedDate = new Date(this.calendar.focusedDate.getFullYear(), this.calendar.focusedDate.getMonth(), 0);
      } else if (this.calendar.focusedDate.getDate() <= 30) {
        if (this.calendar.focusedDate.getMonth() - 1 === 1 && (this.calendar.focusedDate.getDate() === 30 || this.calendar.focusedDate.getDate() === 29)) {
          this.calendar.focusedDate = new Date(this.calendar.focusedDate.getFullYear(), this.calendar.focusedDate.getMonth(), 0);
        } else {
          this.calendar.focusedDate = new Date(this.calendar.focusedDate.getFullYear(), this.calendar.focusedDate.getMonth() - 1, this.calendar.focusedDate.getDate());
        }
      }
    } else {
      if (this.tempDate.getDate() === 31) {
        this.calendar.focusedDate = new Date(this.tempDate.getFullYear(), this.tempDate.getMonth(), 0);
      } else if (this.tempDate.getDate() <= 30) {
        if (this.tempDate.getMonth() - 1 === 1 && (this.tempDate.getDate() === 30 || this.tempDate.getDate() === 29)) {
          this.calendar.focusedDate = new Date(this.tempDate.getFullYear(), this.tempDate.getMonth(), 0);
        } else {
          this.calendar.focusedDate = new Date(this.tempDate.getFullYear(), this.tempDate.getMonth() - 1, this.tempDate.getDate());
        }
      }
    }
  }

  // This event is used for PAGE_DOWN: Go to the same day in the next month

  rangeArrowPageDown() {
    if (this.calendar.focusedDate) {
      if (this.calendar.focusedDate.getDate() === 31) {
        this.calendar.focusedDate = new Date(this.calendar.focusedDate.getFullYear(), this.calendar.focusedDate.getMonth() + 2, 0);
      } else if (this.calendar.focusedDate.getDate() <= 30) {
        if (this.calendar.focusedDate.getMonth() + 1 === 1 && (this.calendar.focusedDate.getDate() === 30 || this.calendar.focusedDate.getDate() === 29)) {
          this.calendar.focusedDate = new Date(this.calendar.focusedDate.getFullYear(), this.calendar.focusedDate.getMonth() + 2, 0);
        } else {
          this.calendar.focusedDate = new Date(this.calendar.focusedDate.getFullYear(), this.calendar.focusedDate.getMonth() + 1, this.calendar.focusedDate.getDate());
        }
      }
    } else {
      if (this.tempDate.getDate() === 31) {
        this.calendar.focusedDate = new Date(this.tempDate.getFullYear(), this.tempDate.getMonth() + 2, 0);
      } else if (this.tempDate.getDate() <= 30) {
        if (this.tempDate.getMonth() + 1 === 1 && (this.tempDate.getDate() === 30 || this.tempDate.getDate() === 29)) {
          this.calendar.focusedDate = new Date(this.tempDate.getFullYear(), this.tempDate.getMonth() + 2, 0);
        } else {
          this.calendar.focusedDate = new Date(this.tempDate.getFullYear(), this.tempDate.getMonth() + 1, this.tempDate.getDate());
        }
      }
    }
  }
  /**
    * Key events for the calendar.
    * TAB: moves focus to calendar.
    * LEFT_ARROW: Go to previous day.
    * RIGHT_ARROW: Go to next day.
    * UP_ARROW: Go to same day in the previous week.
    * DOWN_ARROW: Go to same day in the next week.
    * HOME: Go to the first day in the current range.
    * END: Go to the last day in the current range.
    * PAGE_UP: Go to the same day in the previous month
    * PAGE_DOWN:Go to the same day in the next month
    * ALT + PAGE_UP:Go to the same day in the previous year
    * ALT + PAGE_DOWN:Go to the same day in the next year
    * ENTER:Select current day

    * @param event as KeyboardEvent
    */
  dateUpdateOnKeyPress(dayTempRefs: any, e: any) {
    dayTempRefs.forEach(element => {
      const tempElement = element.btn.nativeElement;
      this.tempDate = new Date(element.calendarInnerRef.date);
      if (e.code === 'Home' || e.keyCode === 36) {
        this.tempDate = new Date(this.tempDate.getFullYear(), this.tempDate.getMonth(), 1);
      } else if (e.code === 'End' || e.keyCode === 35) {
        this.tempDate = new Date(this.tempDate.getFullYear(), this.tempDate.getMonth() + 1, 0);
      }
      if (tempElement.classList.contains('date-selected') || tempElement.classList.contains('date-selected2')) {
        if (e.code === 'ArrowRight' || e.keyCode === 39) {
          this.tempDate.setDate(this.tempDate.getDate() + 1);
        } else if (e.code === 'ArrowLeft' || e.keyCode === 37) {
          this.tempDate.setDate(this.tempDate.getDate() - 1);
        } else if (e.code === 'ArrowDown' || e.keyCode === 40) {
          this.tempDate.setDate(this.tempDate.getDate() + 7);
        } else if (e.code === 'ArrowUp' || e.keyCode === 38) {
          this.tempDate.setDate(this.tempDate.getDate() - 7);
        } else if ((e.code === 'PageUp' || e.keyCode === 33) && e.altKey === false) {
          if (this.tempDate.getDate() === 31) {
            this.tempDate = new Date(this.tempDate.getFullYear(), this.tempDate.getMonth(), 0);
          } else if (this.tempDate.getDate() <= 30) {
            if (this.tempDate.getMonth() - 1 === 1 && (this.tempDate.getDate() === 30 || this.tempDate.getDate() === 29)) {
              this.tempDate = new Date(this.tempDate.getFullYear(), this.tempDate.getMonth(), 0);
            } else {
              this.tempDate = new Date(this.tempDate.getFullYear(), this.tempDate.getMonth() - 1, this.tempDate.getDate());
            }
          }
        } else if ((e.code === 'PageDown' || e.keyCode === 34) && e.altKey === false) {
          if (this.tempDate.getDate() === 31) {
            this.tempDate = new Date(this.tempDate.getFullYear(), this.tempDate.getMonth() + 2, 0);
          } else if (this.tempDate.getDate() <= 30) {
            if (this.tempDate.getMonth() + 1 === 1 && (this.tempDate.getDate() === 30 || this.tempDate.getDate() === 29)) {
              this.tempDate = new Date(this.tempDate.getFullYear(), this.tempDate.getMonth() + 2, 0);
            } else {
              this.tempDate = new Date(this.tempDate.getFullYear(), this.tempDate.getMonth() + 1, this.tempDate.getDate());
            }
          }
        } else if (e.altKey === true && (e.code === 'PageDown' || e.keyCode === 34)) {
          // leap year
          if (this.tempDate.getMonth() === 1 && (this.tempDate.getDate() === 29)) {
            this.tempDate = new Date(this.tempDate.getFullYear() + 1, this.tempDate.getMonth() + 1, 0);
          } else {
            this.tempDate = new Date(this.tempDate.getFullYear() + 1, this.tempDate.getMonth(), this.tempDate.getDate());
          }
        } else if (e.altKey === true && (e.code === 'PageUp' || e.keyCode === 33)) {
          // leap year
          if (this.tempDate.getMonth() === 1 && (this.tempDate.getDate() === 29)) {
            this.tempDate = new Date(this.tempDate.getFullYear() - 1, this.tempDate.getMonth() + 1, 0);
          } else {
            this.tempDate = new Date(this.tempDate.getFullYear() - 1, this.tempDate.getMonth(), this.tempDate.getDate());
          }
        } else {
          this.validKeyPressed = false;
        }

        if (this.validKeyPressed) {
          this.calendar.select(this.tempDate, false);
        }
        this.calendar.daySelected = true;
        if (e.code === 'Enter' || e.keyCode === 13) {
          this.calendar.select(this.tempDate, true);
        }
      }
    });
  }
}
